var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.874 21.906C63.5453 20.6681 62.8971 19.5382 61.9943 18.6296C61.0915 17.7211 59.9658 17.0656 58.73 16.729C54.193 15.505 36 15.505 36 15.505C36 15.505 17.807 15.505 13.27 16.729C12.0342 17.0656 10.9085 17.7211 10.0058 18.6296C9.10296 19.5382 8.45475 20.6681 8.12603 21.906C6.91003 26.472 6.91003 36 6.91003 36C6.91003 36 6.91003 45.528 8.12603 50.095C8.45475 51.3329 9.10296 52.4628 10.0058 53.3714C10.9085 54.28 12.0342 54.9354 13.27 55.272C17.807 56.495 36 56.495 36 56.495C36 56.495 54.193 56.495 58.73 55.272C59.9658 54.9354 61.0915 54.28 61.9943 53.3714C62.8971 52.4628 63.5453 51.3329 63.874 50.095C65.09 45.528 65.09 36 65.09 36C65.09 36 65.09 26.472 63.874 21.906Z",
    fill: "#EA5A47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.05 44.65L45.2561 36L30.05 27.35V44.65Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.874 21.906C63.5453 20.6681 62.8971 19.5382 61.9943 18.6296C61.0915 17.7211 59.9658 17.0656 58.73 16.729C54.193 15.505 36 15.505 36 15.505C36 15.505 17.807 15.505 13.27 16.729C12.0342 17.0656 10.9085 17.7211 10.0058 18.6296C9.10296 19.5382 8.45475 20.6681 8.12603 21.906C6.91003 26.472 6.91003 36 6.91003 36C6.91003 36 6.91003 45.528 8.12603 50.095C8.45475 51.3329 9.10296 52.4628 10.0058 53.3714C10.9085 54.28 12.0342 54.9354 13.27 55.272C17.807 56.495 36 56.495 36 56.495C36 56.495 54.193 56.495 58.73 55.272C59.9658 54.9354 61.0915 54.28 61.9943 53.3714C62.8971 52.4628 63.5453 51.3329 63.874 50.095C65.09 45.528 65.09 36 65.09 36C65.09 36 65.09 26.472 63.874 21.906Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.05 44.65L45.2561 36L30.05 27.35V44.65Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d13644cdc7b07ec9ecda13264d394398.svg";
export { ForwardRef as ReactComponent };